import { useGetAllArticulos } from 'lib/react-query/queries'
import React, { useEffect, useState } from 'react'
import { TABLE_HEADER_ARTICULOS_ADMIN } from 'utils/constant/constantsArticulos'
import ArticuloRowAdmin from './ArticuloRowAdmin'
import Pagination from 'components/ui/Pagination/Pagination'
import { useArticulosTablePage } from 'context/ArticulosTablePageContext'
import NotResultsText from './NotResultsText'
import Skeleton from 'react-loading-skeleton'
import BoxSkeleton from '../BoxSkeleton'

const ArticulosAdminTable = () => {
  const limit = 15
  const [page, setPage] = useState(1)
  const { searchedValue, filterByActive } = useArticulosTablePage()

  const mappedActive = {
    all: undefined,
    enabled: true,
    disabled: false,
  }[filterByActive]

  const { data, isLoading, isFetching } = useGetAllArticulos({
    page: page,
    limit,
    filter: searchedValue,
    active: mappedActive,
  })

  const handlePage = newPage => {
    setPage(newPage)
  }

  useEffect(() => {
    setPage(1)
  }, [searchedValue, filterByActive])

  if (!data || isLoading || isFetching)
    return <Skeleton wrapper={BoxSkeleton} count={12} height={40} />
  if (data.results === 0)
    return (
      <NotResultsText>
        No hay resultados que coincidan con la búsqueda.
      </NotResultsText>
    )
  return (
    <>
      <table className="table-admin">
        <thead>
          <tr>
            {TABLE_HEADER_ARTICULOS_ADMIN.map(({ name, className }, i) => (
              <th className={className}>{name}</th>
            ))}
          </tr>
        </thead>
        <tbody className="articulos-table-body">
          {data.data.data.map(item => (
            <ArticuloRowAdmin
              key={item._id}
              articulo={item}
              highlightInactive={
                (filterByActive === 'all' || filterByActive === 'disabled') &&
                item.active === false
              }
            />
          ))}
        </tbody>
      </table>
      <div style={{ height: '1px' }}></div>
      <div className="pagination-articulos-admin-container">
        {data.total >= limit && (
          <Pagination
            count={2}
            currentPage={page}
            totalPages={Math.ceil(data.total / limit)}
            handlePage={handlePage}
          />
        )}
      </div>
    </>
  )
}

export default ArticulosAdminTable
